import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { NotificationsProvider } from './notifications/NotificationsProvider';
import { RequireAuth } from './auth/RequireAuth';
import { AccountPage } from './pages/AccountPage';
import { AdminPage } from './pages/AdminPage';
import { DashboardEditPage } from './pages/DashboardEditPage';
import { DashboardPage } from './pages/DashboardPage';
import { DashboardsPage } from './pages/DashboardsPage';
import { DatasetDetailPage } from './pages/DatasetDetailPage';
import { DatasetProfilePage } from './pages/DatasetProfilePage';
import { DatasetsPage } from './pages/DatasetsPage';
import { DiscoverPage } from './pages/DiscoverPage';
import { PreparePage } from './pages/PreparePage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { ModerationPage } from './pages/ModerationPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { RegisterPage } from './pages/RegisterPage';
import { SavedPage } from './pages/SavedPage';
import { SearchPage } from './pages/SearchPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { StoriesPage } from './pages/StoriesPage';
import { StoryEditPage } from './pages/StoryEditPage';
import { StoryPage } from './pages/StoryPage';
import { VerifyEmailPage } from './pages/VerifyEmailPage';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      {/* Discovery is reading, and reading is open (Phase 14). */}
      <Route path="/discover" element={<DiscoverPage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route
        path="/saved"
        element={
          <RequireAuth>
            <SavedPage />
          </RequireAuth>
        }
      />
      <Route
        path="/notifications"
        element={
          <RequireAuth>
            <NotificationsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/moderation"
        element={
          <RequireAuth>
            <ModerationPage />
          </RequireAuth>
        }
      />
      <Route
        path="/admin"
        element={
          <RequireAuth>
            <AdminPage />
          </RequireAuth>
        }
      />
      <Route
        path="/account"
        element={
          <RequireAuth>
            <AccountPage />
          </RequireAuth>
        }
      />
      <Route
        path="/dashboards"
        element={
          <RequireAuth>
            <DashboardsPage />
          </RequireAuth>
        }
      />
      {/* Reading follows the resource's visibility, so these are open: a
          public story or dashboard is readable without an account. The backend
          decides — a private one answers 404 to a stranger either way. */}
      <Route path="/dashboards/:dashboardId" element={<DashboardPage />} />
      <Route
        path="/dashboards/:dashboardId/edit"
        element={
          <RequireAuth>
            <DashboardEditPage />
          </RequireAuth>
        }
      />
      <Route
        path="/stories"
        element={
          <RequireAuth>
            <StoriesPage />
          </RequireAuth>
        }
      />
      {/* Reading follows the resource's visibility, so these are open: a
          public story or dashboard is readable without an account. The backend
          decides — a private one answers 404 to a stranger either way. */}
      <Route path="/stories/:postId" element={<StoryPage />} />
      <Route
        path="/stories/:postId/edit"
        element={
          <RequireAuth>
            <StoryEditPage />
          </RequireAuth>
        }
      />
      <Route
        path="/datasets"
        element={
          <RequireAuth>
            <DatasetsPage />
          </RequireAuth>
        }
      />
      {/* Reading follows the resource's visibility, so these are open: a
          public story or dashboard is readable without an account. The backend
          decides — a private one answers 404 to a stranger either way. */}
      <Route path="/datasets/:datasetId" element={<DatasetDetailPage />} />
      <Route
        path="/datasets/:datasetId/prepare"
        element={
          <RequireAuth>
            <PreparePage />
          </RequireAuth>
        }
      />
      {/* A dataset's profile is what it says about itself, so it follows the
          dataset's visibility like the dataset page does. */}
      <Route path="/datasets/:datasetId/profile" element={<DatasetProfilePage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <NotificationsProvider>
          <AppRoutes />
        </NotificationsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
